/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('global.nearby-resorts')
 */
import Component, { getNearbyResortsServerSideProps } from 'page-components/global/nearby-resorts';
import { propsWithI18NSSR } from 'util/propsWithI18n';

export default Component;
export const getServerSideProps = propsWithI18NSSR(getNearbyResortsServerSideProps);
